export enum PriceType {
	None = 0,
	Base = 1,
	Adult = 2,
	Child = 3,
	Infant = 4,
	Group = 5,
	PerBooking = 6
}
